export default __webpack_public_path__ + "static/media/link.a527a339.svg";